<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ویرایش اطلاعات مشتری '{{Edit_Customer_Record.name}}'</h5>
    <form [formGroup]="EdCustomer">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">نام مشتری (*) </label>
          <input type="text" class="form-control" disabled value="{{Edit_Customer_Record.name}}" />
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">کد مشتری (*) </label>
          <input type="text" class="form-control" disabled value="{{Edit_Customer_Record.code}}" />
        </div>
      </div>

      <div class="row" *ngIf="false">

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">استان </label>
          <select class="custom-select" formControlName="ProvinceId" (change)="ProvinceChange()">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_Province" [value]="item.code">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">شهرستان</label>
          <select class="custom-select" formControlName="CityId">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_City" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">زمینه فعالیت</label>
          <select class="custom-select" formControlName="FeildActivity">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_FeildActivity" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
      </div>


      <div class="row" style="display: none;">

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">شماره ثبت</label>
          <input type="number" formControlName="ShomarehSabt" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_ShomarehSabt().valid && get_Form_ShomarehSabt().touched"
            class="form-text text-muted MyErrorRedColor">شماره ثبت را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">کد اقتصادی</label>
          <input type="number" formControlName="CodeEghtesadi" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_CodeEghtesadi().valid && get_Form_CodeEghtesadi().touched"
            class="form-text text-muted MyErrorRedColor">کد اقتصادی را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> کد ملی (بدون صفر اول) </label>
          <input type="number" formControlName="CodeMeli" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_CodeMeli().valid && get_Form_CodeMeli().touched"
            class="form-text text-muted MyErrorRedColor">کد ملی را وارد نمائید.</small>
        </div>
      </div>

      <br />
      <hr />
      <br />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">نام و نام خانوادگی مدیرعامل</label>
          <input type="text" formControlName="ModirAmelName" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

      </div>
      <div class="row" style="display: none;">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">شماره تلفن همراه (بدون صفر اول) </label>
          <input type="number" formControlName="ModirAmelMobile" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_ModirAmelMobile().valid && get_Form_ModirAmelMobile().touched"
            class="form-text text-muted MyErrorRedColor">شماره تلفن همراه را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تلفن</label>
          <input type="number" formControlName="ModirAmelTel" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">داخلی</label>
          <input type="number" formControlName="ModirAmelDakheli" class="form-control"
            placeholder="اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">ایمیل</label>
          <input type="email" formControlName="ModirAmelEmail" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_ModirAmelEmail().valid && get_Form_ModirAmelEmail().touched"
            class="form-text text-muted MyErrorRedColor">ایمیل را وارد نمائید.</small>
        </div>
      </div>
    </form>



    <br />
    <hr />
    <br />

    <h5 *ngIf="AddressForm_Edit_Id==-1"> آدرس </h5>
    <h5 *ngIf="AddressForm_Edit_Id>-1"> ویرایش آدرس </h5>

    <form [formGroup]="AddressCustomer" (submit)="OnSubmit_AddressForm()">

      <input type="hidden" formControlName="id">

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">عنوان آدرس</label>
          <input type="text" formControlName="title" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_AddressCustomer_title().valid && get_Form_AddressCustomer_title().touched"
            class="form-text text-muted MyErrorRedColor">عنوان آدرس را وارد نمائید.</small>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">آدرس</label>
          <input type="text" formControlName="address" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">آدرس گواهی نامه</label>
          <input type="text" formControlName="certificateAddress" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_AddressCustomer_certificateAddress().valid && get_Form_AddressCustomer_certificateAddress().touched"
            class="form-text text-muted MyErrorRedColor">آدرس گواهی نامه را وارد نمائید. (حداکثر 50 کاراکتر) </small>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">کد پستی</label>
          <input type="number" formControlName="codepost" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3" style="display: none;">
          <label for="exampleInputEmail1">صندوق پستی</label>
          <input type="number" formControlName="sandoghpost" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">پیش شماره</label>
          <input type="number" formControlName="pishShomareh" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تلفن</label>
          <input type="number" formControlName="Tel" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3" style="display: none;">
          <label for="exampleInputEmail1">داخلی</label>
          <input type="number" formControlName="Dakheli" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">فاکس</label>
          <input type="number" formControlName="Fax" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>


      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">توضیحات</label>
          <input type="text" formControlName="Dsc" class="form-control" placeholder="اینجا تایپ کنید ...">
        </div>
      </div>



      <button *ngIf="AddressForm_Edit_Id==-1" type="submit" [disabled]="!AddressCustomer.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن آدرس </button>
      <button *ngIf="AddressForm_Edit_Id==-1" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i
          class="fa fa-times-rectangle"></i> لغو </button>

      <button *ngIf="AddressForm_Edit_Id>-1" type="submit" [disabled]="!AddressCustomer.valid" class="btn btn-info"
        style="margin-left: 5px;"><i class="fa  fa-edit"></i> ویرایش آدرس </button>
      <button *ngIf="AddressForm_Edit_Id>-1" type="button" (click)="AddressForm_Edit_Cancel()" class="btn btn-danger"
        style="margin-left: 5px;"><i class="fa fa-times-rectangle"></i> لغو ویرایش </button>

    </form>

    <br />
    <br />

    <div class="table-responsive" *ngIf="DataList_Address.length>0 && AddressForm_Edit_Id==-1">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>عنوان آدرس</th>
            <th>آدرس</th>
            <th>آدرس گواهی نامه</th>
            <th>کد پستی</th>
            <th>پیش شماره</th>
            <th>تلفن</th>
            <th>فاکس</th>
            <th>توضیحات</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataList_Address">
            <td>{{DataList_Address.indexOf(item)+1}}</td>
            <td>{{item.title}}</td>
            <td>{{item.address}}</td>
            <td>{{item.certificateAddress}}</td>
            <td>{{item.codepost}}</td>
            <td>{{item.pishShomareh}}</td>
            <td>{{item.tel}}</td>
            <td>{{item.fax}}</td>
            <td>{{item.dsc}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    امکانات
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="AddressForm_Edit(DataList_Address.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-edit"></i> ویرایش </a>
                    <a style="cursor: pointer;" (click)="AddressForm_Delete(DataList_Address.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <hr />
    <br />

    <app-CutomerKarshnasForm
    [inner_Customer]="-1"
    (outter_KarshnasMasol)="set_KarshnasMasol($event)">
    
    </app-CutomerKarshnasForm>


    <button *ngIf="!Proccesing_OnSubmitForm" type="button" (click)="OnSubmitForm()" [disabled]="!EdCustomer.valid"
      class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus"></i> تایید و ثبت نهایی اطلاعات مشتری
    </button>
    <button *ngIf="Proccesing_OnSubmitForm" type="button" class="btn btn-info" style="margin-left: 5px;"> لطفا صبر
      نمائید ... <i class="fa fa-spin fa-spinner"></i> </button>

  </div>
</div>